<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-6 p-5">
        <div class="mx-auto mb-3">
          <h4 class="d-inline align-middle text-center">
            {{ resetSuccess ? 'Reset password successful' : tokenValid ? 'Fill in personal information to start working with the system'  : 'User reset token expired' }}
          </h4>
        </div>
        <b-form
          @submit.prevent="inviteUsers"
          v-if="tokenValid && !resetSuccess"
        >
          <TextField 
            placeholder="New Password"
            label="New Password *"
            name="password"
            type="password"
            v-model="model.password"
            :error="$v.model.password.$error"
            :errorMessage="passwordError"
          />

          <TextField 
            placeholder="Confirm New Password"
            label="Confirm New Password *"
            name="confirm"
            type="password"
            v-model="model.confirm_password"
            :error="$v.model.confirm_password.$error"
            :errorMessage="$v.model.confirm_password.errorMessage"
          />

          <div class="form-group">
            <button type="submit" class="btn btn-primary btn-block">
              <i class="uil-check"></i> Submit
            </button>
          </div>
        </b-form>
        <router-link v-else to="/" class="btn btn-primary btn-block" tag="button">Back to Login</router-link>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@layouts/default'
import TextField from '@components/form/textfield'
/* import InputTag from 'vue-input-tag' */
import { mapActions } from 'vuex'
import  AuthMixin from '@mixins/auth'
import  FormMixin from '@mixins/form'
import { required, sameAs } from 'vuelidate/lib/validators'
  
export default {
  mixins: [AuthMixin, FormMixin],
  data(){
    return {
      model:{
        password:'',
        confirm_password:'',
        reset_token: ''
      },
      contains: {
        upper: '',
        lower: '',
        number: '',
        special: '',
        length: ''
      },
      tokenValid: false,
      resetSuccess: false,
      passwordError: ''
    }
  },
  components:{Layout, TextField},
  methods:{
    ...mapActions('user', ['updateNewPassword', 'checkResetToken']),
    inviteUsers(){

      if (this.validateForm()) {
				this.toggleLoading()
				return;
      }
      this.model.reset_token = this.$route.query.key
      this.updateNewPassword(this.model).then(res => {
        if(res.data.status){
          this.resetSuccess = true
        }else{
          this.tokenValid = false
        }
      }).catch(() => {
        this.tokenValid = false
      })
    }
  },
  created() {
    this.checkResetToken({
      token:this.$route.query.key
    }).then(result => {
      if(result.data.status){
        this.tokenValid = true
      }else{
        this.tokenValid = false
      }
    }).catch(() => {
      this.$router.push('/')
    })
  },
  validations: {
    model:{
      password: {
        required,
        passwordRule: function(value) {
          let valid = (/[A-Z]/.test(value) && /[a-z]/.test(value) && /[0-9]/.test(value) && /[#?!@$%^&*-]/.test(value) && value.length > 5)

          this.passwordError = (valid ? '' : 'Password must have at least (') + 
          (value.length > 5 ? '' : 'length of 6 characters; ') + 
          (/[A-Z]/.test(value) ? '' : '1 upper case letter; ') + 
          (/[a-z]/.test(value) ? '' : '1 lower case letter; ') + 
          (/[0-9]/.test(value)  ? '' : '1 number; ') + 
          (/[#?!@$%^&*-]/.test(value) ? '' : '1 special character') + 
          (valid ? '' : ')')
          
          return /[A-Z]/.test(value) && /[a-z]/.test(value) && /[0-9]/.test(value) && /[#?!@$%^&*-]/.test(value) && value.length > 5
        }
      },
      confirm_password: {
        sameAsPassword: sameAs('password')
      }
    }
  }
}
</script>